export const DocusignSigningCompleted = 'DocusignSigningCompleted';
export const DocusignSigningDeclined = 'DocusignSigningDeclined';

export function listenForDocusignSigning(win: Window, onCompleted: () => void, onDeclined: () => void): () => void {
    const listener = (event: MessageEvent) => {
        if (event.origin !== win.location.origin) {
            return;
        }

        if (event.data === DocusignSigningCompleted) {
            onCompleted();
        } else if (event.data === DocusignSigningDeclined) {
            onDeclined();
        }
    };

    win.addEventListener('message', listener, false);
    return () => win.removeEventListener('message', listener, false);
}
